import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { first } from 'rxjs/operators';

import { Retention } from '../../../_models';
import { RetentionService, NotificationService, KeywordService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-retention',
  templateUrl: './retention.component.html'
})
export class RetentionComponent implements OnInit {

  filterable = {
    from: null,
    to: null,
    shortCode: null,
    keyword: null,
    affiliate: '',
    operator: null,
    source: null,
    country: null,
    realtime: false
  };

  loading = false;
  processing = false;
  totalItems = 0;
  emptyResult = true;
  retentions: Retention[];
  reports = [];
  sourceList = [];
  countryList: any = {};
  keywordList: any = [];
  shortCodeList: any = [];
  operatorList: any = [];
  affiliateList = [];

  exporting = false;
  active = 0;
  downloadUrl = '';

  allShortCodes = [];
  targetShortCode = null;

  realtimeFlags = {'Realtime': true, 'Offline': false};
  resultName = '';

  constructor(private retentionSvc: RetentionService,
    private keywordSvc: KeywordService,
    private notification: NotificationService,
    private route: ActivatedRoute,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let dte = new Date();
    dte.setDate(dte.getDate() - 1);
    this.filterable.to = dte.toISOString().substring(0, 10);
    dte.setDate(dte.getDate() - 7);
    this.filterable.from = dte.toISOString().substring(0, 10);
    this.loadSources();
    this.loadAllShortCodes();
  }

  search() {
    this.totalItems = 0;
    this.loadPage();
  }

  export() {
    this.exporting = true;
    let params = this.formParam();
    this.retentionSvc.export(params, this.filterable.realtime)
      .subscribe(res => {
        this.downloadUrl = res.data;
        document.getElementById('download').click();
        this.exporting = false;
      });
  }

  openModal(targetModal) {
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });
  }

  onClear() {
    this.filterable.shortCode = null;
    this.filterable.keyword = null;
    this.filterable.affiliate = '';
    this.keywordList = [];
    this.affiliateList = [];
    this.targetShortCode = null;
  }

  gotoTargetShortCode(targetShortCode) {
    if (targetShortCode) {
      let source = this.sourceList.find(it => { return it.value == targetShortCode.source });
      this.changeSource(source, targetShortCode);
    }
  }

  changeSource(source, targetShortCode = null) {
    if (!targetShortCode) {
      this.targetShortCode = null;
    }
    this.filterable.source = source;
    this.shortCodeList = [];
    this.countryList = {};
    this.operatorList = {};
    this.filterable.shortCode = null;
    this.filterable.operator = null;
    this.filterable.country = null;
    if (source) {
      this.countryList = source.subOptions;
      var targetCountry;
      if (targetShortCode) {
        targetCountry = targetShortCode.country;
      } else {
        targetCountry = this.countryList[Object.keys(this.countryList)[0]];
      }
      this.changeCountry(targetCountry, targetShortCode);
    }
  }

  changeCountry(country, targetShortCode = null) {
    if (!targetShortCode) {
      this.targetShortCode = null;
    }
    this.filterable.country = country;
    this.shortCodeList = [];
    this.operatorList = {};
    this.filterable.shortCode = null;
    this.filterable.operator = null;
    if (country) {
      this.keywordSvc.getSelectionShortCodes(this.filterable.source.value, country).subscribe(data => {
        this.operatorList = data.data;
        var targetOperator;
        if (targetShortCode) {
          targetOperator = targetShortCode.operator;
        } else {
          targetOperator = Object.keys(this.operatorList)[0];
        }
        this.changeOperator(targetOperator, targetShortCode);
      });
    }
  }

  changeOperator(operator, targetShortCode = null) {
    if (!targetShortCode) {
      this.targetShortCode = null;
    }
    this.filterable.operator = operator;
    this.shortCodeList = [];
    this.filterable.shortCode = null;
    if (operator) {
      this.shortCodeList = this.operatorList[operator];
      var shortCode;
      if (targetShortCode) {
        shortCode = targetShortCode.shortCode;
      } else {
        shortCode = this.shortCodeList[0];
      }
      this.changeShortCode(shortCode, targetShortCode);
    }
  }

  changeShortCode(shortCode, targetShortCode = null) {
    this.filterable.shortCode = shortCode;
    if (shortCode) {
      this.keywordSvc.getSelectionKws(this.filterable.operator, shortCode).subscribe(data => {
        this.keywordList = data.data;
        this.changeKeyword(this.keywordList[0]);
      });
    }
    if (!targetShortCode) {
      this.targetShortCode = this.allShortCodes.find(it => { return it.shortCode == this.filterable.shortCode && it.operator == this.filterable.operator });
    }
  }

  changeKeyword(keyword) {
    this.filterable.keyword = keyword;
    this.filterable.affiliate = '';
    this.affiliateList = [];
    this.affiliateList = keyword.affiliates;
    if (this.affiliateList && this.affiliateList.length > 0) {
      this.filterable.affiliate = this.affiliateList[0];
    }
  }

  private loadSources() {
    this.keywordSvc.getSelectionSources().pipe(first()).subscribe(data => {
      this.sourceList = data.data;
      let currentSource = this.sourceList.find(it => it.name == 'PAY365');
      if(!currentSource){
        currentSource = data.data[0];
      }
      this.filterable.source = currentSource;
      this.changeSource(this.filterable.source);
    });
  }


  private loadAllShortCodes() {
    this.keywordSvc.allShortCodeForSelection().pipe(first()).subscribe(data => {
      if (data) {
        this.allShortCodes = data.data;
      }
    });
  }

  private loadPage() {
    this.loading = true;
    this.emptyResult = false;
    this.retentions = [];
    this.totalItems = 0;
    let params = this.formParam();

    this.resultName = this.filterable.realtime ? 'Realtime' : 'Offline';
    // get page of items from api
    this.retentionSvc.getAll(params, this.filterable.realtime).pipe(first()).subscribe(data => {

      if (data.status !== null && data.data.length > 0) {
        this.loading = false;
        this.emptyResult = false;
        this.retentions = data.data;
        this.totalItems = data.data.length;
      } else {
        this.loading = false;
        this.emptyResult = true;
        var notiMsg = data.msg == "Awesome!" ? "There is no record for this search." : data.msg;
        this.notification.showWarning(notiMsg, "Empty Result");
      }
    });
  }

  private formParam() {
    let params = {
      from: formatDate(this.filterable.from, 'yyyyMMdd', 'en'),
      to: formatDate(this.filterable.to, 'yyyyMMdd', 'en'),
      shortCode: this.filterable.shortCode,
      keyword: this.filterable.keyword.keyword,
      operator: this.filterable.operator,
      country: this.filterable.country,
      source: this.filterable.source.value,
      affiliate: this.filterable.affiliate
    }
    return params;
  }

}
